import { render, staticRenderFns } from "./commission-report.vue?vue&type=template&id=4ef950a8"
import script from "./commission-report.vue?vue&type=script&lang=ts"
export * from "./commission-report.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports